// extracted by mini-css-extract-plugin
export default {"discover":"Discover_discover__AQ6lT","sidebar":"Discover_sidebar__r3-yd","exploreFeed":"Discover_exploreFeed__3CRma","bottomNav":"Discover_bottomNav__Zivgc"};